import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./login.css";

const Login = ({ setUser, API_URL }) => {
    const navigate = useNavigate();
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const loginUser = async (e) => {
        e.preventDefault();
        if (!login.trim() || !password.trim()) {
            setError("Заполните все поля");
            return;
        }
        setLoading(true);
        setError("");
        try {
            const res = await axios.post(`${API_URL}/login`,
                {
                    login,
                    password
                }
            );
            if (res.data.status === "success") {
                localStorage.setItem("user", JSON.stringify(res.data.user));
                setUser(res.data.user);
                navigate("/home");
            } else {
                setError("Неверный логин или пароль");
            }
        } catch {
            setError("Ошибка соединения с сервером");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-bg">
                <div className="login-bg-circle login-bg-circle1"></div>
                <div className="login-bg-circle login-bg-circle2"></div>
                <div className="login-bg-circle login-bg-circle3"></div>
            </div>

            <div className="login-card">
                <div className="login-logo">
                    <img src="/logo.png" alt="Logo" />
                </div>
                <h1 className="login-title">Войти в систему</h1>
                <p className="login-subtitle">Добро пожаловать! Введите ваши данные.</p>

                <form className="login-form" onSubmit={loginUser}>
                    <div className="login-field">
                        <label>Пользователь</label>
                        <div className="login-input-wrap">
                            <i className="fas fa-user login-icon"></i>
                            <input
                                type="text"
                                placeholder="Введите логин"
                                value={login}
                                onChange={(e) => setLogin(e.target.value)}
                                autoComplete="username"
                            />
                        </div>
                    </div>

                    <div className="login-field">
                        <label>Пароль</label>
                        <div className="login-input-wrap">
                            <i className="fas fa-lock login-icon"></i>
                            <input
                                type={showPassword ? "text" : "password"}
                                placeholder="Введите пароль"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                            />
                            <button
                                type="button"
                                className="login-eye"
                                onClick={() => setShowPassword(!showPassword)}
                                tabIndex={-1}
                            >
                                <i className={`fa-regular ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                            </button>
                        </div>
                    </div>

                    {error && (
                        <div className="login-error">
                            <i className="fas fa-exclamation-circle"></i> {error}
                        </div>
                    )}

                    <button type="submit" className="login-btn" disabled={loading}>
                        {loading ? (
                            <><i className="fas fa-circle-notch fa-spin"></i> Вход...</>
                        ) : (
                            <><i className="fas fa-sign-in-alt"></i> Войти</>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;